var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayground = function SvgPlayground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.62 3.915A1.25 1.25 0 0 0 18.75 5v25a1.25 1.25 0 1 0 2.5 0V19.059l11.037-6.307a1.25 1.25 0 0 0 0-2.17zm8.527 7.752-7.897 4.512V7.154z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.628 30.531a1.25 1.25 0 1 0-1.256-2.162c-1.17.68-2.289 1.775-2.289 3.298 0 1.648 1.313 2.804 2.65 3.472 1.414.708 3.28 1.111 5.267 1.111s3.853-.403 5.267-1.11c1.337-.669 2.65-1.825 2.65-3.473 0-1.502-1.114-2.615-2.29-3.298a1.25 1.25 0 1 0-1.255 2.162c.892.518 1.045.972 1.045 1.136 0 .185-.188.696-1.268 1.236-1.002.501-2.47.847-4.149.847-1.68 0-3.147-.346-4.15-.847-1.08-.54-1.267-1.051-1.267-1.236 0-.177.148-.615 1.045-1.136"
  })));
};
export default SvgPlayground;